import React, { useState, useEffect } from "react";
import YouTube from "./Youtube";

const YoutubePlayer = React.memo(({socket, currentVideo}) => {

    const [player, setPlayer] = useState(null);
    const verbosePausePlay = false;

    useEffect(() => {
        if (currentVideo.videoID == '') {
            setPlayer(null)
        }
        return setPlayer(null);
    }, [currentVideo]);

    useEffect(() => {
        if (socket != null && player !=null){
            socket.on('pauseClients', () => {

                if (player.getPlayerState() === 1) {
                    player.pauseVideo();
                    verbosePausePlay && console.log('Server requests video pause')
                }
            });
            socket.on('playClients', (res) => {
                if (player.getPlayerState() === 2) {
                    player.seekTo(res)
                    player.playVideo()
                    verbosePausePlay && console.log('Resuming video at: '+res)
                }
                if (player.getPlayerState() === 5) {
                    player.playVideo()
                    verbosePausePlay && console.log('Resuming video from queued position')
                }
            });
        }
    }, [player]);

    const onEnd = (e) => {
        verbosePausePlay && console.log('Video has ended: Requesting next video')
        setPlayer(null)
        socket.emit('PlayNext', currentVideo.queueUUID)
    }

    const onReady = (e) => {
        setPlayer(e.target)
    }

    const onPause = (e) => {
        verbosePausePlay && console.log('Sending pause: '+e.target.getCurrentTime())
        socket.emit('requestPauseVideo', {time: e.target.getCurrentTime()})
    }

    const onPlay = (e) => {
        socket.emit('requestPlayVideo', {videoUUID: currentVideo.queueUUID, time: e.target.getCurrentTime()})
        verbosePausePlay && console.log('Sending play: '+e.target.getCurrentTime())
    }


    const onPlaybackRateChange = (e) => {
        e.target.setPlaybackRate(1)
    }

    const opts = {

        playerVars: {
            autoplay: currentVideo.paused ? 0:1,
            start: currentVideo.currentTime
        },
    }

    return (
        <div className='YoutubePlayer'>
            <div style={{visibility: currentVideo.videoID == '' ? 'hidden': 'visible'}}>
                <YouTube videoId={currentVideo.videoID} opts={opts} onPlaybackRateChange={onPlaybackRateChange} onEnd={onEnd} onReady={onReady} onPause={onPause} onPlay={onPlay}/>
            </div>
        </div>
    )
}, (prevProps, nextProps) => (prevProps.currentVideo === nextProps.currentVideo && prevProps.socket === nextProps.socket));

export default YoutubePlayer;